import { render } from "./SottoProgettoListaFornitori.vue?vue&type=template&id=5c15afb8&ts=true"
import script from "./SottoProgettoListaFornitori.vue?vue&type=script&lang=ts"
export * from "./SottoProgettoListaFornitori.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__